import React, { Component } from 'react';
import { Container, Form, Col, Button, Table, Modal, Spinner } from 'react-bootstrap';
import axios from 'axios'
import { Redirect } from 'react-router-dom'
import jsPDF from 'jspdf'
import { AdminNav, RequestModal, RiceTypeModal, Loading } from '../../helpers';
import font from '../../helpers/THSarabun-normal'
import { convertRiceTypeTHToEN, convertRiceTypeENToTH, getCompanyFromDescription } from '../../helpers/function';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import '../datepicker.css'
import TextInput from 'react-autocomplete-input';
import 'react-autocomplete-input/dist/bundle.css';

class Request extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validated: false,
      validatedLicense: false,
      modalShow: false,
      licenseID: '',
      LicenseDetail: [],
      description: [{}],
      shippingDate: new Date(this.props.history.location.date) || '',
      subID: 0,
      dataReady: false,
      Company: null,
      redirect: false,
      riceTitles: [],
      showErrorModal: false,
      modalContent: null,
      changwatsArray: [],
      amphoesArray: [],
      amphoesArrayFilltered: [],
      isPushNewData: false,
      showShippingDate: new Date(this.props.history.location.date) || '',
      companyNameTH: null,
      surveyPaidByName: null,
      viewAllSurveyEN: [],
      viewAllSurveyTH: [],
      riceTypeModalShow: true,
      showRiceTypeModal: false,
      isRiceTypeModal: false,
      modalRiceTypeContent: null,
      riceTypeIDAndName: [],
      isTotalNumberComplete: false,
      isDupNumberComplete: false,
      isNewNumberComplete: false,
      riceTypeIDAndNameTotalNumber: 'x',
      riceTypeIDAndNameNewNumber: 'x',
      riceTypeIDAndNameDupNumber: 'x',
      isSurveyComplete: false,
      isCreateSurveyComplete: false,
      submitCount: 0,
      networkStatus: null,
      alertCompany: false,
      isHandleNetwork: false,
      alreadySubmit: false,
      riceForSearch: [],
      godown : ''
    }
    this.HandleChange = this.HandleChange.bind(this)
    this.renderRiceType = this.renderRiceType.bind(this)
    this.handleRiceType = this.handleRiceType.bind(this)
    this.HandleChangeChangwats = this.HandleChangeChangwats.bind(this)
    this.onChageDate = this.onChageDate.bind(this)
    this.handleSearchCompleteCompany = this.handleSearchCompleteCompany.bind(this)
    this.handleSearchCompleteSurveyPaidBy = this.handleSearchCompleteSurveyPaidBy.bind(this)
    this.handleCompleteCompanyAndSurveyPaidBy = this.handleCompleteCompanyAndSurveyPaidBy.bind(this)
    this.renderRiceTypeModal = this.renderRiceTypeModal.bind(this)
    this.riceTypeModalHide = this.riceTypeModalHide.bind(this)
    this.handleChangeRiceNameToRiceType = this.handleChangeRiceNameToRiceType.bind(this)
    this.HandleChangeAmphoes = this.HandleChangeAmphoes.bind(this)
    this.renderAlertCompany = this.renderAlertCompany.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.HandleChangeSurveyEN = this.HandleChangeSurveyEN.bind(this)
  }
  componentWillMount() {
    let startTime = new Date()
    let viewAllCompanyPromise = fetch(`https://backend1.riceinspections.com/testAB`).then((res) => {
      return res.json()
    })
    let viewAllSurveyTHPromise = fetch(`https://backend1.riceinspections.com/testBA`).then((res) => {
      return res.json()
    })
    let viewAllSurveyENPromise = fetch(`https://backend1.riceinspections.com/testBB`).then((res) => {
      return res.json()
    })
    let viewAllRiceTitlesPromise = fetch(`https://backend1.riceinspections.com/testBC`).then((res) => {
      return res.json()
    })
    let viewAllRiceTypeIDAndNamePromise = fetch(`https://backend1.riceinspections.com/testE`).then((res) => {
      return res.json()
    })
    let viewAllSurveyPromise = fetch(`https://backend1.riceinspections.com/testBD`).then((res) => {
      return res.json()
    })

    // https://raw.githubusercontent.com/ignitry/thai-tambons/master/dist/thailand.json
    let getChangwatsPromise = axios.get(
      'https://raw.githubusercontent.com/ignitry/thai-tambons/master/dist/changwats.json',
    )
    let getAmphoesPromise = axios.get(
      'https://raw.githubusercontent.com/ignitry/thai-tambons/master/dist/amphoes.json',
    )
    Promise.all([viewAllCompanyPromise, viewAllRiceTitlesPromise, getChangwatsPromise, getAmphoesPromise,
      viewAllSurveyTHPromise, viewAllSurveyENPromise, viewAllRiceTypeIDAndNamePromise, viewAllSurveyPromise])
      .then((res) => {
        console.log((new Date() - startTime) / 1000)
        // console.log(res)
        let Company = res[0]
        let riceTitles = res[1]
        let changwatsArray = res[2]['data']
        let amphoesArray = res[3]['data']
        let viewAllSurveyTH = res[4]
        let viewAllSurveyEN = res[5]
        let viewAllRiceTypeIDAndName = res[6]
        let viewAllSurvey = res[7]
        viewAllSurveyTH = []
        viewAllSurveyEN = []
        // console.log(viewAllSurveyTH)
        viewAllSurvey = Object.values(viewAllSurvey)
        viewAllSurvey.map(o => { 
          if(o['surveyNameTH']){
            viewAllSurveyTH.push(o['surveyNameTH'])
          }
          if(o['surveyNameEN']){
            viewAllSurveyEN.push(o['surveyNameEN'])
          }
         })
        // console.log(viewAllSurveyTH)
        let newChangwatsArray = []
        Object.keys(changwatsArray).map((idx) => {
          newChangwatsArray.push(changwatsArray[idx]['name']['th'])
        })
        console.log(amphoesArray)
        let newAmphoesArray = []
        Object.values(amphoesArray).map((amphoesData) => {
          newAmphoesArray.push(amphoesData['name']['th'])
        })
        // console.log(viewAllSurvey)
        // newChangwatsArray.sort((a, b) => a.name.th.localeCompare(b.name.th, 'th'))
        this.setState({
          ...this.state,
          Company: Company,
          riceTitles: riceTitles,
          changwatsArray: newChangwatsArray,
          amphoesArray: newAmphoesArray,
          viewAllSurveyTH: viewAllSurveyTH,
          viewAllSurveyEN: viewAllSurveyEN,
          riceTypeIDAndName: viewAllRiceTypeIDAndName,
          viewAllSurvey: viewAllSurvey
        }, () => {
          let riceForSearch = []
          Object.values(this.state.riceTitles).map((title) => {
            let convertIndex = convertRiceTypeENToTH(title, this.state.riceTypeIDAndName)
            let convertIndexLength = convertIndex.length
            if (convertIndexLength == 1) {
              riceForSearch.push(convertIndex)
            } else if (convertIndexLength > 1) {
              Object.values(convertIndex).map((riceTitles) => {
                riceForSearch.push(riceTitles['riceTypeName'])
              })
            }
          })
          this.setState({
            ...this.state,
            riceForSearch: riceForSearch
          })
        })
      }).catch((err) => {
        this.setState({
          ...this.state,
          networkStatus: 'การเชื่อมต่ออินเทอร์เน็ตมีปัญหา'
        })
      })
  }
  createRequest() {
    this.setState({
      ...this.state,
      showRiceTypeModal: true,
    })
    console.log(this.state)
  }
  handleSubmitAll = () => {
    this.refs.form1.dispatchEvent(new Event('submit'))
  }
  handleSubmitModal = (obj, cb, idx) => {
    let currentState = this.state
    let newobj = { ...obj, licenseID: this.state.licenseID }
    let newLicenseDetail = [...this.state.LicenseDetail, newobj]
    let newState = {
      ...currentState,
      description: {
        ...this.state.description,
        [this.state.LicenseDetail.length]: {
          licenseID: this.state.licenseID,
          subID: idx,
          quantity: obj.WeightLeft,
          destinationCity: obj.Destination,
          exchangeRate: obj.ExchangeRate,
          pricePerUnit: obj.PricePerUnit,
          bagQuantity: obj.Quantity,
          bagType: obj.QuantityUnit,
        },
      },
      LicenseDetail: newLicenseDetail,
    }
    console.log(obj)
    this.setState(newState, () => { console.log(this.state) })
    cb()
  }

  handleSubmitAllModal = (arr, companyDescription, cb) => {
    let { licenseID, LicenseDetail, description } = this.state;
    let topIDX = 0
    let objArr = {}
    Object.keys(description).map((idx) => {
      if (Object.keys(description[idx]).length > 0) {
        objArr = {
          ...objArr,
          [topIDX]: {
            ...description[topIDX],
            destinationCity: description[topIDX]['Destination'],
            exchangeRate: description[topIDX]['ExchangeRate'],
            pricePerUnit: description[topIDX]['PricePerUnit'],
            bagQuantity: description[topIDX]['Quantity'],
            bagType: description[topIDX]['QuantityUnit'],
          }
        }
        topIDX++
      }
    })
    console.log(arr)
    arr.map((obj, idx) => {
      obj.licenseID = licenseID;
      obj.subID = idx;
      obj.quantity = obj.WeightLeft
      obj.destinationCity = obj.Destination
      obj.exchangeRate = obj.ExchangeRate
      obj.pricePerUnit = obj.PricePerUnit
      obj.bagQuantity = obj.Quantity
      obj.bagType = obj.QuantityUnit
      obj.netWeight = parseFloat((obj.WeightLeft / obj.Quantity) * 1000).toFixed(6)
      objArr = {
        ...objArr,
        [parseInt(topIDX) + parseInt(idx)]: obj,
      }
    })
    let newLicenseDetail = [...LicenseDetail, ...arr]
    this.setState({
      ...this.state,
      LicenseDetail: newLicenseDetail,
      description: objArr,
      companyDescription: companyDescription,
    }, () => {
      this.handleCompleteCompanyAndSurveyPaidBy()
    })
    cb();
  }
  HandleChangeDescription = (e, idx) => {
    if (e.target.id == 'grossWeight' || e.target.id == 'netWeight') {
      this.setState({
        ...this.state,
        description: {
          ...this.state.description,
          [idx]: {
            ...this.state.description[idx],
            [e.target.id]: parseFloat(e.target.value),
          },
        },
      })
    } else {
      this.setState({
        ...this.state,
        description: {
          ...this.state.description,
          [idx]: {
            ...this.state.description[idx],
            [e.target.id]: e.target.value,
          },
        },
      })
    }
  }

  handleDeleteDescription = (e, idx) => {
    let { LicenseDetail } = this.state;
    let newDescription = Object.assign({}, this.state.description);
    delete newDescription[idx];
    let newLicense = LicenseDetail.filter((license, index) => index !== idx);
    this.setState({
      ...this.state,
      LicenseDetail: newLicense,
      description: Object.values(newDescription),
    }, () => console.log(this.state))
  }

  HandleChange = (e) => {
    this.setState({
      ...this.state,
      [e.target.id]: e.target.value,
    }
    )
  }
  HandleChangeSurveyTH = (e) => {
    console.log(e)
    let viewAllSurvey = this.state.viewAllSurvey
    let groupData = viewAllSurvey.filter((o) => {
      return o['surveyNameTH'] == e
    })
    console.log(groupData)
    if (groupData.length > 0) {
      console.log(groupData[0]['amphoes'], groupData[0]['changwat'], groupData[0]['surveyNameEN'])
      this.setState({
        ...this.state,
        ['surveyLocateName']: e,
        ['godown']: groupData[0]['surveyNameEN'],
        ['surveyProvince']: groupData[0]['changwat'],
        ['surveyDistrict']: groupData[0]['amphoes']
      }
      )
    } else {
      this.setState({
        ...this.state,
        ['surveyLocateName']: e,
      }
      )
    }
  }
  HandleChangeSurveyEN = (e) => {
    console.log(e)
    if(e){
      this.setState({
        ...this.state,
        ['godown']: e,
      }
      )
    }
  }
  HandleChangeAmphoes = (e) => {
    console.log(e)
    this.setState({
      ...this.state,
      ['surveyDistrict']: e,
    }
    )
  }

  HandleChangeChangwats = (e) => {
    // const changeChangwatToID = (EN) => {
    //   let output = nullHandleChangeChangwats
    //   Object.keys(this.state.changwatsArray).map((changwatID) => {
    //     if (this.state.changwatsArray[changwatID]['name']['en'] == EN) {
    //       output = this.state.changwatsArray[changwatID]['id']
    //     }
    //   })
    //   return output
    // }
    console.log(e)
    let changwatsEN = e
    // let newAmphoesArr = []
    // Object.values(this.state.amphoesArray).map((amphoe) => {
    //   if (amphoe.changwat_id == changeChangwatToID(changwatsEN)) {
    //     newAmphoesArr.push(amphoe)
    //   }
    // })
    // console.log(newAmphoesArr)
    // newAmphoesArr.sort((a, b) => a.name.th.localeCompare(b.name.th, 'th'))

    this.setState({
      ...this.state,
      ['surveyProvince']: changwatsEN,
      // amphoesArrayFilltered: newAmphoesArr,
    })
  }

  HandleIntChange = (e) => {
    this.setState({
      [e.target.id]: parseInt(e.target.value),
    })
  }
  handleSubmit(event) {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (form.checkValidity() === true) {
      event.preventDefault();
      this.setState({ dataReady: true })
      this.createRequest()
    }
    this.setState({ validated: true });
  }
  handleRiceType = (e, idx) => {
    this.state.description[idx].riceTypeID = convertRiceTypeTHToEN(e, this.state.riceTypeIDAndName)
    // this.state.description[idx].riceTypeName = e
    this.setState({
      ...this.state,
      description: {
        ...this.state.description,
        [idx]: {
          ...this.state.description[idx],
          riceTypeName: e,
          riceTypeID: e,
          wtf: e,
        }
      }
    })
  }
  modalClose = () => {
    this.setState({ modalShow: false })
  }
  modalShow = (e) => {
    e.preventDefault()
    if (e.currentTarget.checkValidity() === false) {
      e.stopPropagation()
    }
    this.setState({ validatedLicense: true })
    if (this.state.licenseID.length === 13) {
      this.setState({ modalShow: true })
    }

  }
  renmodal = () => {
    if (this.state.modalShow) {
      if (this.state.licenseID.length === 13) {
        return (
          <RequestModal submit={this.handleSubmitModal} submitAll={this.handleSubmitAllModal} licenseID={this.state.licenseID} show={this.state.modalShow} onHide={this.modalClose}></RequestModal>
        )
      }
    }
  }
  riceTypeModalHide = () => {
    this.setState({
      ...this.state,
      riceTypeModalShow: false
    })
  }
  renderRiceTypeModal = (idx, handleRiceType, riceForSearch) => {
    return (
      <RiceTypeModal onHide={this.riceTypeModalHide} idx={idx} riceForSearch={riceForSearch} handleRiceType={handleRiceType} show={this.state.riceTypeModalShow}></RiceTypeModal>
    )
  }

  renderRiceType(riceParaGraph, idx) {
    let riceDescription = riceParaGraph['ProductDescription']
    let stripIndex = riceDescription.indexOf('บรรจุ')
    if (stripIndex > 0 && this.state.description[idx].riceTypeName === undefined) {
      let riceTypeID = riceDescription.slice(0, stripIndex).trim()
      // console.log(riceTypeID)
      this.state.description[idx].riceTypeName = riceTypeID
    } else if (riceDescription && this.state.description[idx].riceTypeName === undefined) {
      let riceTypeID = riceDescription
      // console.log(riceTypeID)
      this.state.description[idx].riceTypeName = riceTypeID
    }
    let riceForSearch = this.state.riceForSearch
    return (
      <div>
        <input value={this.state.description[idx].riceTypeName} onChange={(e) => { this.handleRiceType(e.target.value, idx) }} list="brow" />
        <datalist id="brow">
          {(() => {
            return riceForSearch.map((titileRice) => {
              return <option value={titileRice} />
            })
          })()}
        </datalist>
      </div>

    )
    // }

  }
  toggleModal = (content) => {
    const { showErrorModal } = this.state;
    this.setState({
      ...this.state,
      showErrorModal: !showErrorModal,
      modalContent: content,
      isPushNewData: false
    })
  }
  toggleRiceTypeModal = () => {
    const { showRiceTypeModal } = this.state;
    this.setState({
      ...this.state,
      showRiceTypeModal: !showRiceTypeModal,
      isRiceTypeModal: false
    })
  }

  getModalContent = () => {
    const { modalContent } = this.state;
    switch (modalContent) {
      case 'error':
        return 'เกิดข้อผิดพลาด.'
      //Todo add error case
      case 'internet':
        return 'ไม่สามารถเชื่อมต่ออินเทอร์เน็ตได้'
      default:
        return 'เกิดข้อผิดพลาด.'
    }
  }
  handleChangeRiceNameToRiceType = (riceTypeIDInput, idx) => {
    let a = {
      ...this.state.description,
      [idx]: {
        ...this.state.description[idx],
        wtf: riceTypeIDInput,
        riceTypeID: riceTypeIDInput,
      }
    }
    a[idx]['wtf'] = riceTypeIDInput
    this.setState({
      ...this.state,
      description: a
    }, () => { console.log(this.state.description) })
    // this.state.description[idx].riceTypeID = riceTypeID
  }
  getRiceTypeModalContent = () => {
    const description = this.state.description
    console.log(description)
    // console.log(this.state.alreadySubmit,this.state.showRiceTypeModal)
    if (description[0]?.['riceTypeName']) {
      let a = []
      let riceForSearch = []
      Object.values(this.state.riceTitles).map((title) => {
        riceForSearch.push(title)
      })
      Object.values(description).map((data, idz) => {
        if (convertRiceTypeTHToEN(data['riceTypeName'], this.state.riceTypeIDAndName)) {
          // data['wtf'] = convertRiceTypeTHToEN(data['riceTypeName'],this.state.riceTypeIDAndName)
          data['wtf'] = data['TariffType']
          a.push(
            <tr>
              <td><p>{data['riceTypeName']}</p></td>
              <td><p>{convertRiceTypeTHToEN(data['riceTypeName'], this.state.riceTypeIDAndName)}</p></td>
            </tr>
          )
        } else {
          data['wtf'] = data['TariffType']

          // this.state.alreadySubmit = true
          // a.push(
          //   <tr>
          //     <td><p>{data['riceTypeName']}</p></td>
          //     <td>
          //       <Form.Group as={Col}>
          //         <TextInput Component='input'
          //           regex={''} spacer={''} maxOptions={10}
          //           onChange={(e) => {this.handleChangeRiceNameToRiceType(e,idz) }}
          //           className='form-control' trigger={''} options={riceForSearch} />
          //       </Form.Group>
          //     </td>
          //   </tr>
          // )
        }
      })
      // console.log(this.state.alreadySubmit , this.state.showRiceTypeModal)
      if (this.state.alreadySubmit == false && this.state.showRiceTypeModal) {
        console.log(this.state.alreadySubmit)
        this.handleSubmitCreateSurveySheet()
        return a
      } else {
        return a
      }
    }
  }
  onChageDate = (date) => {
    date = new Date(date)
    let yearNum = date.getFullYear()
    let monthNum = parseInt(date.getMonth()) + 1
    let dayNum = date.getDate()
    let hrNum = date.getHours()
    let minNum = date.getMinutes()
    if (parseInt(hrNum) < 10) {
      hrNum = `0${hrNum}`
    }
    if (parseInt(minNum) == 0) {
      minNum = '00'
    }
    if (parseInt(monthNum) < 10) {
      monthNum = `0${monthNum}`
    }
    if (parseInt(dayNum) < 10) {
      dayNum = `0${dayNum}`
    }
    let saveDate = `${yearNum}-${monthNum}-${dayNum}T${hrNum}:${minNum}`
    this.setState({
      ...this.state,
      shippingDate: saveDate,
      showShippingDate: date,
    })
  }

  handleCompleteCompanyAndSurveyPaidBy() {
    if (this.state.companyDescription) {
      console.log(this.state.companyDescription)
      let part = getCompanyFromDescription(this.state.companyDescription)
      part = part?.slice(6, part.length) 
      let a = Object.values(this.state.Company).filter((o) => {
        let word = o.companyNameTH?.replace(/\s/g, '')
        return part?.trim() == word
      })
      console.log(a)
      if ((part?.trim() !== this.state.companyNameTH?.replace(/\s/g, '') && this.state.companyNameTH?.replace(/\s/g, '')) && part != undefined) {
        // console.log(this.state.description)
        let licenseID = this.state.licenseID
        let description = Object.values(this.state.description).filter((o) => { return o.licenseID != licenseID })
        // console.log(description)
        let newDescription = Object.assign({}, description)
        // console.log(newDescription)
        let { LicenseDetail } = this.state;
        console.log(this.state.LicenseDetail)

        let newLicense = LicenseDetail.filter((o, index) => o.licenseID !== licenseID);

        this.setState({
          ...this.state,
          companyNameAlert: part.trim(),
          alertCompany: true,
          description: newDescription,
          LicenseDetail: newLicense
        })
        // console.log(this.state.description)

        // this.handleDeleteDescription('',)
      } else {
        if (a.length && a.length > 0) {
          let companyNameTH = a[0]['companyNameTH']
          this.setState({
            ...this.state,
            companyID: companyNameTH,
            companyNameTH: companyNameTH,
            surveyPaidBy: companyNameTH,
            surveyPaidByName: companyNameTH,
          })
        }
        else {
          this.setState({
            ...this.state,
            companyID: part,
            companyNameTH: part,
            surveyPaidBy: part,
            surveyPaidByName: part,
          }, () => {
            // console.log(`not if ${this.state.surveyPaidByName} ${this.state.companyNameTH}`)
          })
        }

      }
    }

  }
  handleSearchCompleteCompany(e) {
    if (this.state.companyNameTH == null) {
      let part = getCompanyFromDescription(this.state.companyDescription)
      if (part) {
        part = part.slice(6, part.length)
        let a = Object.values(this.state.Company).filter((o) => part.trim() == o.companyNameTH)
        if (a.length && a.length > 0) {
          let companyNameTH = a[0]['companyNameTH']
          this.setState({
            ...this.state,
            companyID: companyNameTH,
            companyNameTH: companyNameTH,
          }, () => {
            // console.log(`if ${this.state.companyID} ${this.state.companyNameTH} ${companyNameTH}`)
          })
        } else {
          this.setState({
            ...this.state,
            companyNameTH: e,
          }, () => {
            // console.log(`not if ${this.state.companyID} ${this.state.companyNameTH}`)
          })
        }
      } else {
        let a = Object.values(this.state.Company).filter((o) => e.trim() == o.companyNameTH)
        if (a.length && a.length > 0) {
          let companyNameTH = a[0]['companyNameTH']
          this.setState({
            ...this.state,
            companyID: a[0]['companyNameTH'],
            companyNameTH: a[0]['companyNameTH'],
          }, () => {
            // console.log(`if 2 ${this.state.companyID} ${this.state.companyNameTH} ${companyNameTH}`)
          })
        } else {
          this.setState({
            ...this.state,
            companyNameTH: e,
          }, () => {
            // console.log(`not if 2${this.state.companyID} ${this.state.companyNameTH}`)
          })
        }
      }
    } else {
      let part = e
      let a = Object.values(this.state.Company).filter((o) => part.trim() == o.companyNameTH)
      console.log(e, a.length)
      if (a.length && a.length > 0) {
        this.setState({
          ...this.state,
          companyID: a[0]['companyNameTH'],
          companyNameTH: a[0]['companyNameTH']
        }, () => {
          // console.log(`else ${this.state.companyID} ${this.state.companyNameTH}`)
        })
      } else {
        this.setState({
          ...this.state,
          companyID: e,
          companyNameTH: e,
        }, () => {
          // console.log(`not else ${this.state.companyID} ${this.state.companyNameTH}`)
        })
      }
    }
  }
  handleSearchCompleteSurveyPaidBy(e) {
    if (this.state.surveyPaidByName == null) {
      let part = getCompanyFromDescription(this.state.companyDescription)
      if (part) {
        part = part.slice(6, part.length)
        let a = Object.values(this.state.Company).filter((o) => part.trim() == o.companyNameTH)
        // console.log(a[0])
        if (a.length && a.length > 0) {
          this.setState({
            ...this.state,
            surveyPaidBy: a[0]['companyNameTH'],
            surveyPaidByName: a[0]['companyNameTH']
          }, () => {
            // console.log(`if ${this.state.companyID} ${this.state.surveyPaidByName}`)
          })
        } else {
          this.setState({
            ...this.state,
            surveyPaidByName: e,
          }, () => {
            // console.log(`not if ${this.state.companyID} ${this.state.companyNameTH}`)
          })
        }
      } else {
        let a = Object.values(this.state.Company).filter((o) => e.trim() == o.companyNameTH)
        if (a.length && a.length > 0) {
          let companyNameTH = a[0]['companyNameTH']
          this.setState({
            ...this.state,
            surveyPaidBy: companyNameTH,
            surveyPaidByName: companyNameTH,
          }, () => {
            // console.log(`if 2 ${this.state.companyID} ${this.state.companyNameTH} ${companyNameTH}`)
          })
        } else {
          this.setState({
            ...this.state,
            surveyPaidBy: e,
            surveyPaidByName: e,
          }, () => {
            // console.log(`not if 2${this.state.companyID} ${this.state.companyNameTH}`)
          })
        }
      }
    } else {
      let part = e
      let a = Object.values(this.state.Company).filter((o) => part.trim() == o.companyNameTH)
      if (a.length && a.length > 0) {
        this.setState({
          ...this.state,
          surveyPaidBy: a[0]['companyNameTH'],
          surveyPaidByName: a[0]['companyNameTH']
        }, () => {
          // console.log(`else ${this.state.companyID} ${this.state.companyNameTH}`)
        })
      } else {
        this.setState({
          ...this.state,
          surveyPaidBy: e,
          surveyPaidByName: e,
        }, () => {
          // console.log(`not else ${this.state.companyID} ${this.state.companyNameTH}`)
        })
      }
    }
  }
  handleSubmitCreateSurveySheet = () => {
    if (this.state.submitCount == 0) {
      this.state.submitCount = 1
      this.state.isHandleNetwork = false
      let arrCreateRiceTypeIDAndNamePromise = []
      Object.values(this.state.description).map((data) => {
        if (data['riceTypeID']) {
          data['riceTypeID'] = data['riceTypeID'].replace(/\s+|\(+|\)+|\%+/g, '')
        } else if (data['wtf']) {
          data['riceTypeID'] = data['wtf'].replace(/\s+|\(+|\)+|\%+/g, '')
        }
        arrCreateRiceTypeIDAndNamePromise.push([axios.post('https://backend1.riceinspections.com/testAC',{ data: data })])}
        )

      this.setState({
        ...this.state,
        isTotalNumberComplete: 'complete',
        isDupNumberComplete: 'loading',
        isNewNumberComplete: 'loading',
        isSurveyTHComplete: 'loading',
        isSurveyENComplete: 'loading',
        riceTypeIDAndNameTotalNumber: arrCreateRiceTypeIDAndNamePromise.length
      })
      // console.log(this.state.description)
      let a = Promise.all(arrCreateRiceTypeIDAndNamePromise).then((res) => {
        let dupNumber = 0
        let newNumber = 0
        console.log(res)
        Object.values(res).map((resData) => {
          if (resData['status'] == 'dup') {
            dupNumber += 1
          } else if (resData['status'] == 'new') {
            newNumber += 1
          }
        })
        this.setState({
          ...this.state,
          isDupNumberComplete: 'complete',
          isNewNumberComplete: 'complete',
          riceTypeIDAndNameNewNumber: newNumber,
          riceTypeIDAndNameDupNumber: dupNumber,
        })
      }).catch(() => {
        this.setState({
          ...this.state,
          isTotalNumberComplete: false,
          isDupNumberComplete: false,
          isNewNumberComplete: false,
          isSurveyTHComplete: false,
          isSurveyENComplete: false,
          isCreateSurveyComplete: false,
          riceTypeIDAndNameTotalNumber: 'x'
        })
        if (this.state.submitCount == 1 && this.state.isHandleNetwork == false) {
          this.toggleModal('internet')
          console.log('err a')
          this.state.submitCount = 0
          this.state.isHandleNetwork = true
          this.state.alreadySubmit = true
        }
      })
      Promise.all([a]).then(() => {
        this.setState({
          ...this.state,
          isCreateSurveyComplete: 'loading',
          isSurveyENComplete: 'complete',
          isSurveyTHComplete: 'complete',

        },  
        () => {
          console.log(this.state)
          let postData = {
             ...this.state,
             amphoesArray : '',
             amphoesArrayFilltered : '',
             changwatsArray : '',
             riceForSearch : '',
             riceTitles : '',
             riceTypeIDAndName : '',
             viewAllSurvey :'',
             viewAllSurveyEN : '',
             viewAllSurveyTH :'',
          }
          axios.post(
            'https://backend1.riceinspections.com/testBE',
            { data: postData }).then((res) => {
              console.log(res)
              if (res) {
                this.setState({
                  ...this.state,
                  isCreateSurveyComplete: 'complete',
                })
                this.setState({
                  ...this.state,
                  // redirect: true,
                  isPushNewData: false,
                })
                setTimeout(() => {
                  this.props.history.push({
                    pathname: '/requestTable',
                    // state: this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id],
                    state: {
                      timeValue: this.props.location.state.timeValue,
                      timeShow: this.props.location.state.timeShow,
                    },
                  })
                }, 800)
              } else {
                this.setState({
                  ...this.state,
                  isTotalNumberComplete: false,
                  isDupNumberComplete: false,
                  isNewNumberComplete: false,
                  isSurveyTHComplete: false,
                  isSurveyENComplete: false,
                  isCreateSurveyComplete: false,
                  riceTypeIDAndNameTotalNumber: 'x'
                })
                if (this.state.submitCount == 1 && this.state.isHandleNetwork == false) {
                  this.toggleModal('internet')
                  this.state.submitCount = 0
                  this.state.isHandleNetwork = true
                  this.state.alreadySubmit = true
                }
              }
            }).catch((err) => {
              console.log('laser err')
              this.setState({
                ...this.state,
                isTotalNumberComplete: false,
                isDupNumberComplete: false,
                isNewNumberComplete: false,
                isSurveyTHComplete: false,
                isSurveyENComplete: false,
                isCreateSurveyComplete: false,
                riceTypeIDAndNameTotalNumber: 'x'
              })
              if (this.state.submitCount == 1 && this.state.isHandleNetwork == false) {
                this.toggleModal('internet')
                this.state.submitCount = 0
                this.state.isHandleNetwork = true
                this.state.alreadySubmit = true
              }
            })
        }
        )
      })
    }
  }
  spinnerAndCheck = (isComplete) => {
    if (isComplete == 'complete') {
      return '✓'
    } else if (isComplete == 'loading') {
      return <Spinner animation="border" size="sm" variant="primary" />
    } else {
      return <div></div>
    }
  }
  renderAlertCompany(alertCompany, licenseID, companyName) {
    if (alertCompany) {
      setTimeout(() => {
        this.setState({
          ...this.state,
          alertCompany: false,
        })
      }, 3000)
      return <Loading mode='displayText' title='is' closeModal={this.closeModal} licenseID={licenseID} companyName={companyName} />
    } else {
      return <div></div>
    }
  }
  closeModal() {
    this.setState({
      ...this.state,
      alertCompany: false
    })
  }
  handleKeyPress(e, name, idx) {
    if (e.which == 13) {
      let resultIdx = parseInt(idx) + 1
      if (resultIdx < this.state.LicenseDetail.length) {
        document.getElementById(`${name}${resultIdx}`).focus()
        e.preventDefault()
      }
    }

  }

  render() {
    const { validated, validatedLicense, Company, showRiceTypeModal, showErrorModal } = this.state;
    const renmodal = this.renmodal()
    if (!Company || this.state.isPushNewData) {
      return (
        <Container>
          <AdminNav></AdminNav>
          <Loading title={this.state.networkStatus} />
        </Container>
      )
    }
    if (this.state.redirect) {
      return <Redirect to="/requestTable" />
    }
    let CompanyForSearch = []
    Object.values(Company).map((o) => {
      CompanyForSearch.push(o['companyNameTH'])
    })

    return (
      <Container tabIndex={-1}>
        <AdminNav></AdminNav>
        <Form
          ref="form1"
          noValidate
          validated={validated}
          onSubmit={e => this.handleSubmit(e)}
        >
          <Form.Row>
            <Form.Group as={Col} md="5">
              <Form.Label>ชื่อผู้ส่งออก</Form.Label>
              <br></br>
              <TextInput Component='input' value={this.state.companyNameTH} regex={''} spacer={''} maxOptions={10} onChange={this.handleSearchCompleteCompany} className='form-control' trigger={''} options={CompanyForSearch} />
            </Form.Group>
            <Form.Group as={Col} md="5">
              <Form.Label>วันเวลาที่จะบรรทุก</Form.Label>
              <br></br>
              <DatePicker
                className='form-control'
                selected={this.state.showShippingDate}
                onChange={(date) => { this.onChageDate(date) }}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                timeCaption="time"
                dateFormat="MMMM d, yyyy H:mm"
              />
            </Form.Group>
          </Form.Row>
          <Form.Row >

            <Form.Group as={Col} md="5">
              <Form.Label>ชื่อผู้ขอตรวจสอบ</Form.Label>
              <Form.Control type="text" required id="requestBy" onChange={this.HandleChange} />
              <Form.Control.Feedback type="invalid">
                กรุณาระบุชื่อผู้ขอตรวจสอบ
              </Form.Control.Feedback>
              <Form.Label>เรียกเก็บเงิน</Form.Label>
              <br></br>
              <TextInput Component='input' value={this.state.surveyPaidByName} regex={''} spacer={''} maxOptions={10} onChange={this.handleSearchCompleteSurveyPaidBy} className='form-control' trigger={''} options={CompanyForSearch} />
            </Form.Group>
            <Form.Group as={Col} md="5">
              <Form.Label>เบอร์ติดต่อ</Form.Label>
              <Form.Control type="text" required id="tel" onChange={this.HandleChange} />
              <Form.Control.Feedback type="invalid">
                กรุณาระบุเบอร์ติดต่อ
              </Form.Control.Feedback>
              <Form.Label>เบอร์ติดต่อ</Form.Label>
              <Form.Control type="text" required id="tel" onChange={this.HandleChange} />
              <Form.Control.Feedback type="invalid">
                กรุณาระบุเบอร์ติดต่อ
              </Form.Control.Feedback>

            </Form.Group>



          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} md="3">
              <Form.Label>สถานที่ตรวจสอบ</Form.Label>
              <TextInput Component='input' regex={''} spacer={''} maxOptions={10} onChange={this.HandleChangeSurveyTH} className='form-control' trigger={''} options={this.state.viewAllSurveyTH} />

            </Form.Group>
            <Form.Group as={Col} md="3">
              <Form.Label>สถานที่ตรวจสอบ (EN)</Form.Label>
              <TextInput Component='input' regex={''} spacer={''} maxOptions={10} onChange={this.HandleChangeSurveyEN} className='form-control' trigger={''} options={this.state.viewAllSurveyEN} value={this.state.godown || ''} />
            </Form.Group>
            <Form.Group as={Col} md="3">
              <Form.Label>จังหวัด</Form.Label>
              {/* <Form.Control as="select" required id="surveyProvince" onChange={this.HandleChangeChangwats}> */}
              <TextInput Component='input' regex={''} spacer={''} maxOptions={10} onChange={this.HandleChangeChangwats} className='form-control' trigger={''} options={this.state.changwatsArray} value={this.state.surveyProvince} />

              {/* </Form.Control> */}

            </Form.Group>
            <Form.Group as={Col} md="3">
              <Form.Label>อำเภอ</Form.Label>
              {/* <option value="">โปรดเลือก</option>
                <option value=""> </option>
                {Object.keys(this.state.amphoesArrayFilltered).map((a) => {
                  let c = this.state.amphoesArrayFilltered[a]
                  return (
                    <option type="number" value={c.name.en}>{c.name.th}</option>
                  )
                })} */}
              <TextInput Component='input' regex={''} spacer={''} maxOptions={10} id="surveyDistrict" onChange={this.HandleChangeAmphoes} className='form-control' trigger={''} options={this.state.amphoesArray} value={this.state.surveyDistrict} />

            </Form.Group>
          </Form.Row>
          <Form.Control style={{ display: 'none' }} type="submit" />
        </Form>
        <Form noValidate
          validated={validatedLicense}
          onSubmit={this.modalShow}>
          <Form.Row>
            <Form.Group as={Col} md="3">
              <Form.Control type="text" placeholder="เลขที่ใบอนุญาต" required id="licenseID" onChange={this.HandleChange} pattern="[0-9]{13}">
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                กรุณากรอกเลขที่ใบอนุญาตให้ถูกต้อง
              </Form.Control.Feedback>
            </Form.Group>
            <Button variant="success" onClick={this.modalShow}>เพิ่มใบอนุญาต</Button>
          </Form.Row>
        </Form>
        {renmodal}
        <Table responsive style={{ tableLayout: 'fixed', fontSize: '16px' }}>
          <thead>
            <tr>
              <th style={{ width: '4.5%', overflow: 'auto' }}></th>
              <th style={{ width: '4.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>รายการที่</p></th>
              <th style={{ width: '9.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>เลขที่ใบอนุญาต</p></th>
              <th style={{ width: '10.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>ชนิดข้าว</p></th>
              <th style={{ width: '6.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>ปริมาณ</p></th>
              <th style={{ width: '6.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>ชนิดกระสอบ</p></th>
              <th style={{ width: '6.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>Grossweight</p></th>
              <th style={{ width: '6.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>Netweight</p></th>
              <th style={{ width: '6.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>Mark</p></th>
              <th style={{ width: '6.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>ชื่อพาหนะ</p></th>
              <th style={{ width: '4.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>ประเทศปลายทาง</p></th>
            </tr>
          </thead>
          <tbody>
            {this.state.LicenseDetail.map((a, idx) => (
              <tr>
                <td style={{ overflow: 'hidden' }}><Button tabIndex={-1} variant="outline-danger" onClick={(e) => this.handleDeleteDescription(e, idx)}>ลบ</Button></td>
                <td style={{ overflow: 'auto' }}><p tabIndex={-1} style={{ width: '6.5%', fontSize: '14px' }}>{(parseInt(this.state.description[idx]['subID']) + 1)}</p></td>
                <td style={{ overflow: 'auto' }}><p tabIndex={-1} style={{ fontSize: '14px' }}>{(a.licenseID)}</p></td>
                <td style={{ overflow: 'auto' }}><p tabIndex={-1} style={{ fontSize: '12px' }}>{this.renderRiceType(a, idx)}</p></td>
                <td style={{ overflow: 'hidden' }}><input tabIndex={-1} style={{ width: '100%' }} type="number" placeholder={'คงเหลือ ' + a.WeightLeft + ' ตัน'} id={`quantity${idx}`} onKeyPress={(e) => { this.handleKeyPress(e, 'quantity', idx) }} onChange={(e) => { this.HandleChangeDescription(e, idx) }} value={this.state.description[idx]['quantity']}></input></td>
                <td style={{ overflow: 'hidden' }}><p tabIndex={-1} style={{ width: '100%', fontSize: '14px' }}>{a.QuantityUnit}</p></td>
                <td style={{ overflow: 'hidden' }}><input tabIndex={1} style={{ width: '100%' }} type="number" id={`grossWeight${idx}`} onKeyPress={(e) => { this.handleKeyPress(e, 'grossWeight', idx) }} onChange={(e) => { this.HandleChangeDescription(e, idx) }}></input></td>
                <td style={{ overflow: 'hidden' }}><input tabIndex={2} style={{ width: '100%' }} type="number" id={`netWeight${idx}`} onKeyPress={(e) => { this.handleKeyPress(e, 'netWeight', idx) }} onChange={(e) => { this.HandleChangeDescription(e, idx) }} value={this.state.description[idx]['netWeight']}></input></td>
                <td style={{ overflow: 'hidden' }}><input tabIndex={3} style={{ width: '100%' }} type="text" id={`logo${idx}`} onKeyPress={(e) => { this.handleKeyPress(e, 'logo', idx) }} onChange={(e) => { this.HandleChangeDescription(e, idx) }}></input></td>
                <td style={{ overflow: 'hidden' }}><input tabIndex={4} style={{ width: '100%' }} type="text" id={`vehicleName${idx}`} onKeyPress={(e) => { this.handleKeyPress(e, 'vehicleName', idx) }} onChange={(e) => { this.HandleChangeDescription(e, idx) }}></input></td>
                <td style={{ overflow: 'hidden' }}><p style={{ width: '100%', fontSize: '14px' }}>{a.Destination}</p></td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Modal show={showErrorModal} onClick={this.toggleModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>เกิดข้อผิดพลาด</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {this.getModalContent()}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={this.toggleModal}>ปิด</Button>
          </Modal.Footer>
        </Modal>
        {/* {console.log(showRiceTypeModal)} */}

        <Modal show={showRiceTypeModal} onHide={() => { }} onClick={() => { }} centered>
          <Modal.Header onClick={this.toggleRiceTypeModal} closeButton>
            <Modal.Title> ชนิดข้าว </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Table bordered hover style={{ tableLayout: 'fixed' }}>
              <thead>
                <tr>
                  <th style={{ overflow: 'auto', fontSize: '11px' }}>ชื่อข้าว (ไทย) </th>
                  <th style={{ overflow: 'auto', fontSize: '11px' }}>ชื่อข้าว (อังกฤษ)</th>
                </tr>
              </thead>
              <tbody >
                {this.getRiceTypeModalContent()}
              </tbody>
            </Table>
            <p>ตรวจสอบชนิดข้าว {this.state.riceTypeIDAndNameTotalNumber} ชนิด {this.spinnerAndCheck(this.state.isTotalNumberComplete)}</p>
            <p>เพิ่มชนิดข้าว {this.state.riceTypeIDAndNameNewNumber} ชนิด {this.spinnerAndCheck(this.state.isNewNumberComplete)}</p>
            <p>ชนิดข้าวที่มีอยู่แล้ว {this.state.riceTypeIDAndNameDupNumber} ชนิด {this.spinnerAndCheck(this.state.isDupNumberComplete)}</p>
            <p>บันทึกสถานที่ตรวจสอบ (ไทย) {this.spinnerAndCheck(this.state.isSurveyTHComplete)}</p>
            <p>บันทึกสถานที่ตรวจสอบ (EN) {this.spinnerAndCheck(this.state.isSurveyENComplete)}</p>
            <p>กำลังบันทึกข้อมูล {this.spinnerAndCheck(this.state.isCreateSurveyComplete)}</p>

          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={() => { this.handleSubmitCreateSurveySheet() }}>ยืนยัน</Button>
          </Modal.Footer>
        </Modal>
        {this.renderAlertCompany(this.state.alertCompany, this.state.licenseID, this.state.companyNameAlert)}
        {/* <Loading style={{display : 'none'}} title={this.state.networkStatus}/>  */}

        <Button style={{ float: 'right' }} onClick={this.handleSubmitAll}>ยืนยัน</Button>
        {/* <Button style={{ float: 'right' }} onClick={this.testRender}>แสดงตัวอย่าง</Button> */}
      </Container>
    )
  }
}



export default Request;
